// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { GetAdminPingData, GetAdminPingErrors, GetAdminPingResponses, GetAuthMeData, GetAuthMeResponses, GetAuthSigninByOrganisasjonsNummerRouteParamData, GetAuthSigninByOrganisasjonsNummerRouteParamErrors, GetAuthSigninByOrganisasjonsNummerRouteParamResponses, GetAuthSigninData, GetAuthSigninErrors, GetAuthSigninResponses, GetAuthSignoutData, GetAuthSignoutResponses, GetAvtalePerioderData, GetAvtalePerioderErrors, GetAvtalePerioderResponses, GetAvtalePrivatData, GetAvtalePrivatErrors, GetAvtalePrivatResponses, GetAvtalerData, GetAvtalerErrors, GetAvtalerForLeverandørCsvData, GetAvtalerForLeverandørCsvErrors, GetAvtalerResponses, GetAvtalerSummaryForLeverandørData, GetAvtalerSummaryForLeverandørErrors, GetAvtalerSummaryForLeverandørResponses, GetAvtaleSelskapData, GetAvtaleSelskapErrors, GetAvtaleSelskapResponses, GetGrunnlagForPeriodeData, GetGrunnlagForPeriodeErrors, GetInnrapporteringsFristerData, GetInnrapporteringsFristerErrors, GetInnrapporteringsFristerForPeriodeData, GetInnrapporteringsFristerForPeriodeErrors, GetInnrapporteringsFristerForPeriodeResponses, GetInnrapporteringsFristerResponses, GetInnstillingerData, GetInnstillingerErrors, GetInnstillingerResponses, GetKundeportalVarslerGlobalData, GetKundeportalVarslerGlobalErrors, GetKundeportalVarslerGlobalResponses, GetMalerdataPerioderData, GetMalerdataPerioderErrors, GetMalerdataPerioderResponses, GetOppgjørForPeriodeData, GetOppgjørForPeriodeErrors, GetOppgjørForPeriodeResponses, GetOrganisasjonerForUserData, GetOrganisasjonerForUserErrors, GetOrganisasjonerForUserResponses, GetSearchAvtalerData, GetSearchAvtalerErrors, GetSearchAvtalerResponses, GetSelskaperData, GetSelskaperErrors, GetSelskaperResponses, GetSelskapsportalUserSelskaperData, GetSelskapsportalUserSelskaperErrors, GetSelskapsportalUserSelskaperResponses, GetSelskapsportalVarslerGlobalData, GetSelskapsportalVarslerGlobalErrors, GetSelskapsportalVarslerGlobalResponses, PostAvbestillAvtaleData, PostAvbestillAvtaleErrors, PostAvbestillAvtaleResponses, PostAvtalePrivatData, PostAvtalePrivatErrors, PostAvtalePrivatResponses, PostAvtaleSelskapData, PostAvtaleSelskapErrors, PostAvtaleSelskapResponses, PostInnrapporteringSimulateData, PostInnrapporteringSimulateErrors, PostInnrapporteringSimulateResponses, PostInnrapporteringUploadData, PostInnrapporteringUploadErrors, PostInnrapporteringUploadResponses, PostInnrapporteringValidateData, PostInnrapporteringValidateErrors, PostInnrapporteringValidateResponses, PostInnstillingerData, PostInnstillingerErrors, PostInnstillingerResponses, PostUgyldigAvtaleData, PostUgyldigAvtaleErrors, PostUgyldigAvtaleResponses, PutAvtalePrivatData, PutAvtalePrivatErrors, PutAvtalePrivatResponses, PutAvtaleSelskapData, PutAvtaleSelskapErrors, PutAvtaleSelskapResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export const getAuthSigninByOrganisasjonsNummerRouteParam = <ThrowOnError extends boolean = false>(options: Options<GetAuthSigninByOrganisasjonsNummerRouteParamData, ThrowOnError>): RequestResult<GetAuthSigninByOrganisasjonsNummerRouteParamResponses, GetAuthSigninByOrganisasjonsNummerRouteParamErrors, ThrowOnError> => (options.client ?? client).get<GetAuthSigninByOrganisasjonsNummerRouteParamResponses, GetAuthSigninByOrganisasjonsNummerRouteParamErrors, ThrowOnError>({ url: '/auth/signin/{organisasjonsNummerRouteParam}', ...options });

export const getAuthSignin = <ThrowOnError extends boolean = false>(options?: Options<GetAuthSigninData, ThrowOnError>): RequestResult<GetAuthSigninResponses, GetAuthSigninErrors, ThrowOnError> => (options?.client ?? client).get<GetAuthSigninResponses, GetAuthSigninErrors, ThrowOnError>({ url: '/auth/signin', ...options });

export const getAuthSignout = <ThrowOnError extends boolean = false>(options?: Options<GetAuthSignoutData, ThrowOnError>): RequestResult<GetAuthSignoutResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAuthSignoutResponses, unknown, ThrowOnError>({ url: '/auth/signout', ...options });

export const getAuthMe = <ThrowOnError extends boolean = false>(options?: Options<GetAuthMeData, ThrowOnError>): RequestResult<GetAuthMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAuthMeResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/auth/me',
    ...options
});

export const postAvtalePrivat = <ThrowOnError extends boolean = false>(options: Options<PostAvtalePrivatData, ThrowOnError>): RequestResult<PostAvtalePrivatResponses, PostAvtalePrivatErrors, ThrowOnError> => (options.client ?? client).post<PostAvtalePrivatResponses, PostAvtalePrivatErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/privat',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAvtaleSelskap = <ThrowOnError extends boolean = false>(options: Options<PostAvtaleSelskapData, ThrowOnError>): RequestResult<PostAvtaleSelskapResponses, PostAvtaleSelskapErrors, ThrowOnError> => (options.client ?? client).post<PostAvtaleSelskapResponses, PostAvtaleSelskapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/selskap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const postAvbestillAvtale = <ThrowOnError extends boolean = false>(options: Options<PostAvbestillAvtaleData, ThrowOnError>): RequestResult<PostAvbestillAvtaleResponses, PostAvbestillAvtaleErrors, ThrowOnError> => (options.client ?? client).post<PostAvbestillAvtaleResponses, PostAvbestillAvtaleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/avbestill/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAvtaler = <ThrowOnError extends boolean = false>(options?: Options<GetAvtalerData, ThrowOnError>): RequestResult<GetAvtalerResponses, GetAvtalerErrors, ThrowOnError> => (options?.client ?? client).get<GetAvtalerResponses, GetAvtalerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler',
    ...options
});

export const getAvtalePrivat = <ThrowOnError extends boolean = false>(options: Options<GetAvtalePrivatData, ThrowOnError>): RequestResult<GetAvtalePrivatResponses, GetAvtalePrivatErrors, ThrowOnError> => (options.client ?? client).get<GetAvtalePrivatResponses, GetAvtalePrivatErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/privat/{id}',
    ...options
});

export const putAvtalePrivat = <ThrowOnError extends boolean = false>(options: Options<PutAvtalePrivatData, ThrowOnError>): RequestResult<PutAvtalePrivatResponses, PutAvtalePrivatErrors, ThrowOnError> => (options.client ?? client).put<PutAvtalePrivatResponses, PutAvtalePrivatErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/privat/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAvtaleSelskap = <ThrowOnError extends boolean = false>(options: Options<GetAvtaleSelskapData, ThrowOnError>): RequestResult<GetAvtaleSelskapResponses, GetAvtaleSelskapErrors, ThrowOnError> => (options.client ?? client).get<GetAvtaleSelskapResponses, GetAvtaleSelskapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/selskap/{id}',
    ...options
});

export const putAvtaleSelskap = <ThrowOnError extends boolean = false>(options: Options<PutAvtaleSelskapData, ThrowOnError>): RequestResult<PutAvtaleSelskapResponses, PutAvtaleSelskapErrors, ThrowOnError> => (options.client ?? client).put<PutAvtaleSelskapResponses, PutAvtaleSelskapErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/selskap/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getAvtalePerioder = <ThrowOnError extends boolean = false>(options?: Options<GetAvtalePerioderData, ThrowOnError>): RequestResult<GetAvtalePerioderResponses, GetAvtalePerioderErrors, ThrowOnError> => (options?.client ?? client).get<GetAvtalePerioderResponses, GetAvtalePerioderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/avtaler/avtalePerioder',
    ...options
});

export const getSelskaper = <ThrowOnError extends boolean = false>(options?: Options<GetSelskaperData, ThrowOnError>): RequestResult<GetSelskaperResponses, GetSelskaperErrors, ThrowOnError> => (options?.client ?? client).get<GetSelskaperResponses, GetSelskaperErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/selskaper',
    ...options
});

export const getOrganisasjonerForUser = <ThrowOnError extends boolean = false>(options?: Options<GetOrganisasjonerForUserData, ThrowOnError>): RequestResult<GetOrganisasjonerForUserResponses, GetOrganisasjonerForUserErrors, ThrowOnError> => (options?.client ?? client).get<GetOrganisasjonerForUserResponses, GetOrganisasjonerForUserErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/selskaper/organisasjoner',
    ...options
});

export const getKundeportalVarslerGlobal = <ThrowOnError extends boolean = false>(options?: Options<GetKundeportalVarslerGlobalData, ThrowOnError>): RequestResult<GetKundeportalVarslerGlobalResponses, GetKundeportalVarslerGlobalErrors, ThrowOnError> => (options?.client ?? client).get<GetKundeportalVarslerGlobalResponses, GetKundeportalVarslerGlobalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/kundeportal/varsler/global',
    ...options
});

export const getSelskapsportalUserSelskaper = <ThrowOnError extends boolean = false>(options?: Options<GetSelskapsportalUserSelskaperData, ThrowOnError>): RequestResult<GetSelskapsportalUserSelskaperResponses, GetSelskapsportalUserSelskaperErrors, ThrowOnError> => (options?.client ?? client).get<GetSelskapsportalUserSelskaperResponses, GetSelskapsportalUserSelskaperErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/user/selskaper',
    ...options
});

export const postInnrapporteringUpload = <ThrowOnError extends boolean = false>(options: Options<PostInnrapporteringUploadData, ThrowOnError>): RequestResult<PostInnrapporteringUploadResponses, PostInnrapporteringUploadErrors, ThrowOnError> => (options.client ?? client).post<PostInnrapporteringUploadResponses, PostInnrapporteringUploadErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/selskapsportal/maalerdata/{organisasjonsNummer}/upload',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getMalerdataPerioder = <ThrowOnError extends boolean = false>(options: Options<GetMalerdataPerioderData, ThrowOnError>): RequestResult<GetMalerdataPerioderResponses, GetMalerdataPerioderErrors, ThrowOnError> => (options.client ?? client).get<GetMalerdataPerioderResponses, GetMalerdataPerioderErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/maalerdata/{organisasjonsNummer}/perioder',
    ...options
});

export const getOppgjørForPeriode = <ThrowOnError extends boolean = false>(options: Options<GetOppgjørForPeriodeData, ThrowOnError>): RequestResult<GetOppgjørForPeriodeResponses, GetOppgjørForPeriodeErrors, ThrowOnError> => (options.client ?? client).get<GetOppgjørForPeriodeResponses, GetOppgjørForPeriodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/maalerdata/{organisasjonsNummer}/periode/oppgjor',
    ...options
});

export const getGrunnlagForPeriode = <ThrowOnError extends boolean = false>(options: Options<GetGrunnlagForPeriodeData, ThrowOnError>): RequestResult<unknown, GetGrunnlagForPeriodeErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetGrunnlagForPeriodeErrors, ThrowOnError>({ url: '/selskapsportal/maalerdata/{organisasjonsNummer}/periode/grunnlag', ...options });

export const postInnrapporteringValidate = <ThrowOnError extends boolean = false>(options: Options<PostInnrapporteringValidateData, ThrowOnError>): RequestResult<PostInnrapporteringValidateResponses, PostInnrapporteringValidateErrors, ThrowOnError> => (options.client ?? client).post<PostInnrapporteringValidateResponses, PostInnrapporteringValidateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/selskapsportal/maalerdata/validate',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const postInnrapporteringSimulate = <ThrowOnError extends boolean = false>(options: Options<PostInnrapporteringSimulateData, ThrowOnError>): RequestResult<PostInnrapporteringSimulateResponses, PostInnrapporteringSimulateErrors, ThrowOnError> => (options.client ?? client).post<PostInnrapporteringSimulateResponses, PostInnrapporteringSimulateErrors, ThrowOnError>({
    ...formDataBodySerializer,
    responseType: 'json',
    url: '/selskapsportal/maalerdata/{organisasjonsNummer}/validate',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

export const getInnrapporteringsFrister = <ThrowOnError extends boolean = false>(options?: Options<GetInnrapporteringsFristerData, ThrowOnError>): RequestResult<GetInnrapporteringsFristerResponses, GetInnrapporteringsFristerErrors, ThrowOnError> => (options?.client ?? client).get<GetInnrapporteringsFristerResponses, GetInnrapporteringsFristerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/maalerdata/frister',
    ...options
});

export const getInnrapporteringsFristerForPeriode = <ThrowOnError extends boolean = false>(options: Options<GetInnrapporteringsFristerForPeriodeData, ThrowOnError>): RequestResult<GetInnrapporteringsFristerForPeriodeResponses, GetInnrapporteringsFristerForPeriodeErrors, ThrowOnError> => (options.client ?? client).get<GetInnrapporteringsFristerForPeriodeResponses, GetInnrapporteringsFristerForPeriodeErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/maalerdata/frister/periode',
    ...options
});

export const getAvtalerForLeverandørCsv = <ThrowOnError extends boolean = false>(options: Options<GetAvtalerForLeverandørCsvData, ThrowOnError>): RequestResult<unknown, GetAvtalerForLeverandørCsvErrors, ThrowOnError> => (options.client ?? client).get<unknown, GetAvtalerForLeverandørCsvErrors, ThrowOnError>({ url: '/selskapsportal/avtaler/{organisasjonsNummer}/csv', ...options });

export const getAvtalerSummaryForLeverandør = <ThrowOnError extends boolean = false>(options: Options<GetAvtalerSummaryForLeverandørData, ThrowOnError>): RequestResult<GetAvtalerSummaryForLeverandørResponses, GetAvtalerSummaryForLeverandørErrors, ThrowOnError> => (options.client ?? client).get<GetAvtalerSummaryForLeverandørResponses, GetAvtalerSummaryForLeverandørErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/avtaler/{organisasjonsNummer}/summary',
    ...options
});

export const getSearchAvtaler = <ThrowOnError extends boolean = false>(options: Options<GetSearchAvtalerData, ThrowOnError>): RequestResult<GetSearchAvtalerResponses, GetSearchAvtalerErrors, ThrowOnError> => (options.client ?? client).get<GetSearchAvtalerResponses, GetSearchAvtalerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/avtaler/{organisasjonsNummer}/search',
    ...options
});

export const postUgyldigAvtale = <ThrowOnError extends boolean = false>(options: Options<PostUgyldigAvtaleData, ThrowOnError>): RequestResult<PostUgyldigAvtaleResponses, PostUgyldigAvtaleErrors, ThrowOnError> => (options.client ?? client).post<PostUgyldigAvtaleResponses, PostUgyldigAvtaleErrors, ThrowOnError>({
    url: '/selskapsportal/avtaler/{organisasjonsNummer}/invalidate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getInnstillinger = <ThrowOnError extends boolean = false>(options: Options<GetInnstillingerData, ThrowOnError>): RequestResult<GetInnstillingerResponses, GetInnstillingerErrors, ThrowOnError> => (options.client ?? client).get<GetInnstillingerResponses, GetInnstillingerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/selskaper/{organisasjonsNummer}/innstillinger',
    ...options
});

export const postInnstillinger = <ThrowOnError extends boolean = false>(options: Options<PostInnstillingerData, ThrowOnError>): RequestResult<PostInnstillingerResponses, PostInnstillingerErrors, ThrowOnError> => (options.client ?? client).post<PostInnstillingerResponses, PostInnstillingerErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/selskaper/{organisasjonsNummer}/innstillinger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getSelskapsportalVarslerGlobal = <ThrowOnError extends boolean = false>(options?: Options<GetSelskapsportalVarslerGlobalData, ThrowOnError>): RequestResult<GetSelskapsportalVarslerGlobalResponses, GetSelskapsportalVarslerGlobalErrors, ThrowOnError> => (options?.client ?? client).get<GetSelskapsportalVarslerGlobalResponses, GetSelskapsportalVarslerGlobalErrors, ThrowOnError>({
    responseType: 'json',
    url: '/selskapsportal/varsler/global',
    ...options
});

export const getAdminPing = <ThrowOnError extends boolean = false>(options?: Options<GetAdminPingData, ThrowOnError>): RequestResult<GetAdminPingResponses, GetAdminPingErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminPingResponses, GetAdminPingErrors, ThrowOnError>({ url: '/admin/ping', ...options });
